<mat-dialog-content>
    <div class="leftSide">
        <div id="div-shape99-leftSide">
            <table>
                <tr>
                    <th>{{'Diamètre' | translate}}</th>
                    <td >
                        <input id="shape99Diameter"
                            type="text"
                            size="4"
                            (keyup.enter)="onEnter($event)"
                            (focus)="$event.target.select()"
                            (focusout)="checkErreurShape99()"
                            (change)="onDiameterChange()"
                            [(ngModel)]="diameter">
                        {{grade}}
                    </td>
                </tr>
                <tr>
                    <th>{{'Angle de départ' | translate}}</th>
                    <td ><input
                            id="shape99StartAngle"
                            type="number"
                            size="4"
                            (keyup.enter)="onEnter($event)"
                            (focus)="$event.target.select()"
                            (focusout)="onBeginningAngleFocusOut()"
                            (change)="getDrawingShape99FromServer()"
                            [(ngModel)]="infoShape99[0].Angle"></td>
                </tr>
            </table>

            <ul>
                <li *ngFor="let erreur of mListErreurShape99" style="color: crimson;">{{erreur}}</li>
            </ul>

            <table class="shape99-table">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>{{'Longueur' | translate}}</th>
                        <th>{{'Angle' | translate}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let lenghtAngle of infoShape99; let i = index">
                        <ng-container *ngIf="i > 0">
                            <td>{{i}}</td>
                            <td ><input id="shape99-Lenght-{{i}}"
                                (focus)="onInputLenghtAngleFocus(i)"
                                type="text"
                                size="5"
                                autocomplete="off"
                                (keyup.enter)="onEnter($event)"
                                (focus)="$event.target.select()"
                                (focusout)="checkInputLenghtAngle($event.target, 'Length', i)"
                                (change)="getDrawingShape99FromServer()"
                                [(ngModel)]="lenghtAngle.Length"></td>
                            <td ><input id="shape99-Angle-{{i}}"
                                (focus)="onInputLenghtAngleFocus(i)"
                                type="text"
                                size="5"
                                autocomplete="off"
                                (keyup.enter)="onEnter($event)"
                                (focus)="$event.target.select()"
                                (focusout)="checkInputLenghtAngle($event.target, 'Angle', i)"
                                (change)="getDrawingShape99FromServer()"
                                [(ngModel)]="lenghtAngle.Angle"></td>
                        </ng-container>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="rightSide">
        <div #contentRightSide>
            <img #imgShape99
                style="mix-blend-mode: multiply;"
                *ngIf="mUrlImageShape99 && HTML_ShowRealShape"
                [src]="mUrlImageShape99"
                [width]="mCanvasWidth"
                [height]="mCanvasHeight">
            <arma-shape #armaShape99
                *ngIf="!HTML_ShowRealShape"
                [shape99]="infoShape99"
                id="shape99-edit"
                [Entermeasure]="false"
                [width]="mCanvasWidth"
                [height]="mCanvasHeight"></arma-shape>
        </div>
    </div>
</mat-dialog-content>
<div mat-dialog-actions>
    <button mat-raised-button (click)="onDialogBtnClick('OK')">{{'OK' | translate}}</button>
    <button mat-raised-button color="warn" (click)="onDialogBtnClick('CANCEL')">{{'Annuler' | translate}}</button>
    <button mat-raised-button color="accent" (click)="onDialogBtnClick('CLEAR')">{{'Effacer' | translate}}</button>
</div>
